import React, { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import logo from '../../img/LOGO_GMI_aero.png'
import { Page, Text, Svg, Polyline, Document, StyleSheet, Polygon, G, Circle, Image, View } from '@react-pdf/renderer';
import { PDFViewer } from '@react-pdf/renderer';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Switch from '@mui/material/Switch';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import BarChartRoundedIcon from '@material-ui/icons/Settings';
import ImageUploading from 'react-images-uploading';
import LastVerification from './LastVerification';
import Charts from '../dashboard/charts/Charts';


// style pour les switch(on/off)
const runCallback = (cb) => {
  return cb();
};

const Android12Switch = styled(Switch)(({ theme }) => ({
  padding: 8,
  '& .MuiSwitch-track': {
    borderRadius: 22 / 2,
    '&:before, &:after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 16,
      height: 16,
    },
    '&:before': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main),
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      left: 12,
    },
    '&:after': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main),
      )}" d="M19,13H5V11H19V13Z" /></svg>')`,
      right: 12,
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 16,
    height: 16,
    margin: 2,
  },
}));
// styles pour la page (react)
const useStyles = makeStyles((theme) => ({
  root: {
    width: '140vh', marginLeft: 'auto', marginRight: 'auto'
  },
  divButton: {
    margin: '5',
    alignItems: 'center',
    justifyContent: 'center',
    left: '40%'
  },
  button: {
    margin: '5',
    left: '45%'
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  delete: {
    background: "#f1f1f1",
    color: 'blue ',
    borderRadius: 20,
    position: 'relative',
    margin: '10px',
    float: 'right',
    '&:hover': {
      color: 'white',
      background: "Blue",
      cursor: 'pointer',
      boxShadow: '3px 3px 3px blue'
    }
  },
  clickedd: {
    background: "red",
    color: 'white ',
    borderRadius: 20,
    position: 'relative',
    margin: '10px',
    float: 'right',
    '&:hover': {
      color: 'red',
      background: "#f1f1f1",
      cursor: 'pointer',
      boxShadow: '3px 3px 3px red'
    }
  }

}));
// styles pour le document PDF
const styles = StyleSheet.create({
  page: { padding: 27 },
  textSmall: {
    fontSize: 12,

  },
  superSmall: {
    fontSize: 9,

  },
  smallest: {
    fontSize: 6,

  },
  title: {
    fontSize: 12,
    textAlign: 'center'
  },
  photo: {
    position: "fixed",
    bottom: 0,
    right: 0
  },
  column: {
    float: 'right',
    width: '30%'
  },
  delete: {
    background: "#f1f1f1",
    color: 'blue ',
    borderRadius: 20,
    marginLeft: 10,
    position: 'flex',
    right: 0,
    '&:hover': {
      color: 'white',
      background: "red",
    }
  },
  headerLogo: {
    width: '55px', maxHeight: '30px', top: 5, left: 5, position: 'absolute'
  },
  headerID: {
    fontSize: 10,
    position: 'absolute',
    textAlign: 'right',
    top: 10,
    right: 10,
    color: 'black'
  },
  copyRight: {
    position: 'absolute',
    fontSize: 6,
    bottom: 10,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'black',
  },
  cycleIdHeader: {
    position: 'absolute',
    fontSize: 10,
    top: 10,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'black',
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 8,
    bottom: 10,
    left: 0,
    right: 10,
    textAlign: 'right',
    color: 'black',
  }
});
function getSteps() {
  return ['Report Header', 'Chart period selection', 'Configuration', 'Verification', 'Final Report'];
}

// tapisThermocouple les donnees zid et no
// logoim src du logo ajouter par l'utilisateur
// themoImages les images rajoutees au niveau de l'onglet tapis thermocouples
// vacuumImage les images rajoutees au niveau de l'onglet vacuum bag 
// myimagelistl es images rajoutees au niveau de l'onglet recipe
// comm commentaire rajouter 
//activeFirstPart si l'utilisateur a coche la premiere partie dans le report header
//entete[0][24] les donnees de l'enetete


function getStepContent(descriptionCourbe,listEvents, conditionChiffre, setConditionChiffre, mesTemperatures, setImgSource, typeAnita, urlCaptureImage, imprim, remarks, setRemarks, tapisThermocouple, logoim, setLogoim, themoImages, vacuumImage, myimagelist, comm, activeFirstPart, setActiveFirstPart, openParam, toggleOpenParam, setEntete, entete, classes, step, information, numberplies, setNumberplies, angles, setAngles, value, setValue, open, handleSubmit, dialogValue, setDialogValue, toggleOpen, handleClose, remarksAuto, calculatedangles, setCalculatedangles, description, setDescription, activeCircle, setActiveCircle, activeDesc, setActiveDesc, textColor, setTextColor, matUsed, additionalElements, imgSource, additionalElementsPictures) {
  var grey = textColor

  const onChangez = (logoim, addUpdateIndex) => {
    // data for submit
    setLogoim(logoim)
  };

  const black = "black"
  const beige = "#F5F5DC"
  var firstGap = 170
  var matUsedGap = 0
  var secondGap = 0
  const thirdGap = 0

  var longThirdPart = "180"
  numberplies > 8 ? longThirdPart = "250" : longThirdPart = "200"
  var current = 0;

  function fromCSV(name) {
    var verif = false;
    typeAnita[1].map((csv_dateOfCure) => {
      if (csv_dateOfCure.startsWith(name)) {
        verif = csv_dateOfCure;
      }
    })
    return verif;
  }

  switch (step) {
    case 0:
      console.log(fromCSV('Date of cure'))
      return (
        <div style={{ textAlign: 'center' }}>

          <Image src={urlCaptureImage[0]} style={{ height: 200, width: 200 }} />

          <div id='x'></div>
          {openParam ? <><span style={{ backgroundColor: "#FFF8DC", border: "1px solid #FFA07A", borderRadius: '10px', width: "1000px", textAlign: 'center', display: "inline-block", color: '#FF6347' }}>
            {openParam ? < BarChartRoundedIcon title="a" className={classes.clickedd} onClick={() => toggleOpenParam(!openParam)} /> : < BarChartRoundedIcon title="a" className={classes.delete} onClick={() => toggleOpenParam(!openParam)} />}
            SETTINGS
            <br /><> Change inputs labels</>
            <br />

            <div style={{ textAlign: 'center' }}>

              <br />
              <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                <TextField
                  label={entete[0]}
                  helperText={"maximum 16 characters"}
                  error={entete[0].length >= 16}
                  inputProps={{ maxLength: 16 }}
                  style={{ width: '200px' }}
                  sx={{ m: 1, width: '25ch' }}
                  FormHelperTextProps={{
                    onClick: () => alert("Clicked!")
                  }}
                  onChange={(e) => {
                    entete[0] = e.target.value
                    setEntete(entete => [...entete]);
                  }}
                  value={entete[0]}
                />
                <br></br>
                <FormControlLabel
                  control={<Android12Switch defaultChecked checked={!activeFirstPart} onChange={(e) => { setActiveFirstPart(!activeFirstPart) }} />}
                  label={activeFirstPart ? "Exclude this part" : "Include this part"}
                />

                <TextField
                  disabled={activeFirstPart}
                  label={entete[1]}
                  helperText={"maximum 24 characters"}
                  error={entete[1].length >= 24}
                  inputProps={{ maxLength: 24 }}
                  style={{ width: '200px' }}
                  sx={{ m: 1, width: '25ch' }}
                  onChange={(e) => {
                    entete[1] = e.target.value
                    setEntete(entete => [...entete]);
                  }}
                  value={entete[1]}
                />

                <TextField
                  disabled={activeFirstPart}
                  label={entete[2]}
                  style={{ width: '200px' }}
                  helperText={"maximum 13 characters"}
                  error={entete[2].length >= 13}
                  inputProps={{ maxLength: 13 }}
                  sx={{ m: 1, width: '25ch' }}
                  onChange={(e) => {
                    entete[2] = e.target.value
                    setEntete(entete => [...entete]);
                  }}
                  value={entete[2]}
                /> </div>
              <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                <TextField

                  disabled={activeFirstPart}
                  label={entete[3]}
                  style={{ width: '200px' }}
                  sx={{ m: 1, width: '25ch' }}
                  helperText={"maximum 8 characters"}
                  error={entete[3].length >= 8}
                  inputProps={{ maxLength: 8 }}
                  onChange={(e) => {
                    entete[3] = e.target.value
                    setEntete(entete => [...entete]);
                  }}
                  value={entete[3]}
                />
                <TextField
                  helperText={"maximum 5 characters"}
                  error={entete[4].length >= 5}
                  inputProps={{ maxLength: 5 }}
                  disabled={activeFirstPart}
                  label={entete[4]}
                  style={{ width: '200px' }}
                  sx={{ m: 1, width: '25ch' }}

                  onChange={(e) => {
                    entete[4] = e.target.value
                    setEntete(entete => [...entete]);
                  }}
                  value={entete[4]}
                />
                <TextField
                  helperText={"maximum 16 characters"}
                  error={entete[5].length >= 16}
                  inputProps={{ maxLength: 16 }}
                  disabled={activeFirstPart}
                  label={entete[5]}
                  style={{ width: '200px' }}
                  sx={{ m: 1, width: '25ch' }}
                  onChange={(e) => {
                    entete[5] = e.target.value
                    setEntete(entete => [...entete]);
                  }}
                  value={entete[5]}
                />

                <TextField
                  helperText={"maximum 6 characters"}
                  error={entete[6].length >= 6}
                  inputProps={{ maxLength: 6 }}
                  disabled={activeFirstPart}
                  label={entete[6]}
                  style={{ width: '200px' }}
                  sx={{ m: 1, width: '25ch' }}
                  onChange={(e) => {
                    entete[6] = e.target.value
                    setEntete(entete => [...entete]);
                  }}
                  value={entete[6]}
                />
              </div>
              <br />
              <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                Repair Unit Data<br />
                <TextField
                  helperText={"maximum 9 characters"}
                  error={entete[7].length >= 11}
                  inputProps={{ maxLength: 11 }}
                  label={entete[7]}
                  style={{ width: '230px' }}
                  sx={{ m: 1, width: '25ch' }}
                  onChange={(e) => {
                    entete[7] = e.target.value
                    setEntete(entete => [...entete]);
                  }}
                  value={entete[7]}
                />
                <TextField
                  helperText={"maximum 13 characters"}
                  error={entete[8].length >= 13}
                  inputProps={{ maxLength: 13 }}
                  label={entete[8]}
                  style={{ width: '230px' }}
                  sx={{ m: 1, width: '25ch' }}
                  onChange={(e) => {
                    entete[8] = e.target.value
                    setEntete(entete => [...entete]);
                  }}
                  value={entete[8]}
                /></div>
              <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                <TextField
                  helperText={"maximum 6 characters"}
                  error={entete[9].length >= 6}
                  inputProps={{ maxLength: 6 }}
                  label={entete[9]}
                  style={{ width: '200px' }}
                  sx={{ m: 1, width: '25ch' }}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">mm</InputAdornment>,
                  }}
                  onChange={(e) => {
                    entete[9] = e.target.value
                    setEntete(entete => [...entete]);
                  }}
                  value={entete[9]}
                />
                <TextField
                  helperText={"maximum 6 characters"}
                  error={entete[10].length >= 6}
                  inputProps={{ maxLength: 6 }}
                  label={entete[10]}
                  style={{ width: '200px' }}
                  sx={{ m: 1, width: '25ch' }}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">mm</InputAdornment>,
                  }}
                  onChange={(e) => {
                    entete[10] = e.target.value
                    setEntete(entete => [...entete]);
                  }}
                  value={entete[10]}
                />
                <TextField
                  helperText={"maximum 6 characters"}
                  error={entete[11].length >= 6}
                  inputProps={{ maxLength: 6 }}
                  label={entete[11]}
                  style={{ width: '200px' }}
                  sx={{ m: 1, width: '25ch' }}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">mm</InputAdornment>,
                  }}
                  onChange={(e) => {
                    entete[11] = e.target.value
                    setEntete(entete => [...entete]);
                  }}
                  value={entete[11]}
                />
                <TextField
                  helperText={"maximum 10 characters"}
                  error={entete[12].length >= 10}
                  inputProps={{ maxLength: 10 }}
                  id="outlined-error"
                  label={entete[12]}
                  style={{ width: '200px' }}
                  sx={{ m: 1, width: '25ch' }}
                  onChange={(e) => {
                    entete[12] = e.target.value
                    setEntete(entete => [...entete]);
                  }}
                  value={entete[12]}
                />
                <TextField
                  helperText={"maximum 10 characters"}
                  error={entete[13].length >= 10}
                  inputProps={{ maxLength: 10 }}

                  id="outlined-error"
                  label={entete[13]}
                  style={{ width: '200px' }}
                  sx={{ m: 1, width: '25ch' }}
                  onChange={(e) => {
                    entete[13] = e.target.value
                    setEntete(entete => [...entete]);
                  }}
                  value={entete[13]}
                />

              </div><br />
              <Button variant="contained" color="primary" style={{ margin: '5px' }} onClick={() => {
                const array1 = ["Company", "Defect - Techlog Ref Number", "Customer Code", "A/C Type", "MSN", "A/C Registration", "Notes", "Part Number", "Serial Number", "Wide", "Length", "Depth", "Position", "Other"]
                array1.map((key, index) => { entete[index] = key });
                setEntete(entete => [...entete]);
              }}>Reset default</Button>
              <Button variant="contained" color="primary" style={{ margin: '5px' }} onClick={() => toggleOpenParam(!openParam)}>Back</Button>





            </div>
            <br /><br />
          </span></> : <>
            <span style={{ backgroundColor: "white", border: "1px solid #00008b4f", borderRadius: '10px', width: "1000px", textAlign: 'center', display: "inline-block", color: 'blue' }}>

              <div className="stopwatch" onClick={() => toggleOpenParam(!openParam)} style={{ marginLeft: '60%' }} >
                <span style={{ width: '120px' }} className={!openParam ? classes.clickedd : classes.delete}>
                  <div > Manage Section Names  {openParam ? < BarChartRoundedIcon title="a" className={classes.clickedd} onClick={() => toggleOpenParam(!openParam)} /> : < BarChartRoundedIcon title="a" className={classes.delete} onClick={() => toggleOpenParam(!openParam)} />}

                  </div>
                </span></div>
              <br /><> Report header data </><br />

              <div style={{ textAlign: 'center' }}>

                <br />
                {activeFirstPart ? <TextField
                  helperText={(35 - entete[14].length) + " characters left"}
                  error={entete[14].length >= 35}
                  inputProps={{ maxLength: 35 }}

                  id="outlined-error"
                  label={entete[0]}
                  style={{ width: '200px' }}
                  sx={{ m: 1, width: '25ch' }}
                  onChange={(e) => {
                    entete[14] = e.target.value
                    setEntete(entete => [...entete]);
                  }}
                  value={entete[14]}
                /> : <><div style={{ display: 'flex', justifyContent: 'space-evenly' }}>

                  <TextField
                    helperText={(35 - entete[14].length) + " characters left"}
                    error={entete[14].length >= 35}
                    inputProps={{ maxLength: 35 }}
                    label={entete[0]}
                    id="outlined-start-adornment"
                    style={{ width: '200px' }}
                    sx={{ m: 1, width: '25ch' }}
                    onChange={(e) => {
                      entete[14] = e.target.value
                      setEntete(entete => [...entete]);
                    }}
                    value={entete[14]}
                  />
                  <TextField
                    helperText={(25 - entete[15].length) + " characters left"}
                    error={entete[15].length >= 25}
                    inputProps={{ maxLength: 25 }}
                    label={entete[1]}
                    id="outlined-start-adornment"
                    style={{ width: '200px' }}
                    sx={{ m: 1, width: '25ch' }}
                    onChange={(e) => {
                      entete[15] = e.target.value
                      setEntete(entete => [...entete]);
                    }}
                    value={entete[15]}
                  />

                  <TextField
                    helperText={(15 - entete[16].length) + " characters left"}
                    error={entete[16].length >= 15}
                    inputProps={{ maxLength: 15 }}

                    label={entete[2]}
                    id="outlined-start-adornment"
                    style={{ width: '200px' }}
                    sx={{ m: 1, width: '25ch' }}
                    onChange={(e) => {
                      entete[16] = e.target.value
                      setEntete(entete => [...entete]);
                    }}
                    value={entete[16]}
                  /> </div>
                  <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                    <TextField
                      helperText={(10 - entete[17].length) + " characters left"}
                      error={entete[17].length >= 10}
                      inputProps={{ maxLength: 10 }}
                      label={entete[3]}
                      id="outlined-start-adornment"
                      style={{ width: '200px' }}
                      sx={{ m: 1, width: '25ch' }}
                      onChange={(e) => {
                        entete[17] = e.target.value
                        setEntete(entete => [...entete]);
                      }}
                      value={entete[17]}
                    />
                    <TextField
                      helperText={(20 - entete[18].length) + " characters left"}
                      error={entete[18].length >= 20}
                      inputProps={{ maxLength: 20 }}
                      label={entete[4]}
                      id="outlined-start-adornment"
                      style={{ width: '200px' }}
                      sx={{ m: 1, width: '25ch' }}

                      onChange={(e) => {
                        entete[18] = e.target.value
                        setEntete(entete => [...entete]);
                      }}
                      value={entete[18]}
                    />
                    <TextField
                      helperText={(35 - entete[19].length) + " characters left"}
                      error={entete[19].length >= 35}
                      inputProps={{ maxLength: 35 }}
                      label={entete[5]}
                      id="outlined-start-adornment"
                      style={{ width: '200px' }}
                      sx={{ m: 1, width: '25ch' }}
                      onChange={(e) => {
                        entete[19] = e.target.value
                        setEntete(entete => [...entete]);
                      }}
                      value={entete[19]}
                    />

                    <TextField
                      helperText={(20 - entete[20].length) + " characters left"}
                      error={entete[20].length >= 20}
                      inputProps={{ maxLength: 20 }}
                      label={entete[6]}
                      id="outlined-start-adornment"
                      style={{ width: '200px' }}
                      sx={{ m: 1, width: '25ch' }}
                      onChange={(e) => {
                        entete[20] = e.target.value
                        setEntete(entete => [...entete]);
                      }}
                      value={entete[20]}

                    /></div></>}

                <br />
                <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                  Repair Unit Data<br />
                  <TextField
                    helperText={(20 - entete[21].length) + " characters left"}
                    error={entete[21].length >= 20}
                    inputProps={{ maxLength: 20 }}
                    label={entete[7]}
                    id="outlined-start-adornment"
                    style={{ width: '230px' }}
                    sx={{ m: 1, width: '25ch' }}
                    onChange={(e) => {
                      entete[21] = e.target.value
                      setEntete(entete => [...entete]);
                    }}
                    value={entete[21]}
                  />
                  <TextField
                    helperText={(18 - entete[22].length) + " characters left"}
                    error={entete[22].length >= 18}
                    inputProps={{ maxLength: 18 }}
                    label={entete[8]}
                    id="outlined-start-adornment"
                    style={{ width: '230px' }}
                    sx={{ m: 1, width: '25ch' }}
                    onChange={(e) => {
                      entete[22] = e.target.value
                      setEntete(entete => [...entete]);
                    }}
                    value={entete[22]}
                  /></div>
                <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                  <TextField
                    helperText={(6 - entete[23].length) + " characters left"}
                    error={entete[23].length >= 6}
                    inputProps={{ maxLength: 6 }}
                    label={entete[9]}
                    id="outlined-start-adornment"
                    style={{ width: '200px' }}
                    sx={{ m: 1, width: '25ch' }}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">mm</InputAdornment>,
                    }}
                    onChange={(e) => {
                      entete[23] = e.target.value
                      setEntete(entete => [...entete]);
                    }}
                    value={entete[23]}
                  />
                  <TextField
                    helperText={(6 - entete[24].length) + " characters left"}
                    error={entete[24].length >= 6}
                    inputProps={{ maxLength: 6 }}
                    label={entete[10]}
                    id="outlined-start-adornment"
                    style={{ width: '200px' }}
                    sx={{ m: 1, width: '25ch' }}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">mm</InputAdornment>,
                    }}
                    onChange={(e) => {
                      entete[24] = e.target.value
                      setEntete(entete => [...entete]);
                    }}
                    value={entete[24]}
                  />
                  <TextField
                    helperText={(6 - entete[25].length) + " characters left"}
                    error={entete[25].length >= 6}
                    inputProps={{ maxLength: 6 }}
                    label={entete[11]}
                    id="outlined-start-adornment"
                    style={{ width: '200px' }}
                    sx={{ m: 1, width: '25ch' }}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">mm</InputAdornment>,
                    }}
                    onChange={(e) => {
                      entete[25] = e.target.value
                      setEntete(entete => [...entete]);
                    }}
                    value={entete[25]}
                  />
                  <TextField
                    helperText={(6 - entete[26].length) + " characters left"}
                    error={entete[26].length >= 6}
                    inputProps={{ maxLength: 6 }}
                    label={entete[12]}
                    id="outlined-start-adornment"
                    style={{ width: '200px' }}
                    sx={{ m: 1, width: '25ch' }}
                    onChange={(e) => {
                      entete[26] = e.target.value
                      setEntete(entete => [...entete]);
                    }}
                    value={entete[26]}
                  />
                  <TextField
                    helperText={(17 - entete[27].length) + " characters left"}
                    error={entete[27].length >= 17}
                    inputProps={{ maxLength: 17 }}
                    label={entete[13]}
                    id="outlined-start-adornment"
                    style={{ width: '200px' }}
                    sx={{ m: 1, width: '25ch' }}
                    onChange={(e) => {
                      entete[27] = e.target.value
                      setEntete(entete => [...entete]);
                    }}
                    value={entete[27]}
                  />

                </div>
                <br />



              </div>
              <br /><br />
            </span></>}


          <br /><br /><br />
        </div>);
    case 1:
      return (<>
        <Charts typeAnita={typeAnita} imgSource={imgSource} setImgSource={setImgSource} mesTemperatures={mesTemperatures} chartCalledFrom={"1"}></Charts>

      </>)
    case 2:
      return (
        <>
          <ImageUploading
            multiple
            value={logoim}
            onChange={onChangez}
            maxNumber={"1"}
            dataURLKey="data_url"
          >
            {({
              imageList,
              onImageUpload,
              onImageRemoveAll,
              onImageRemove,
              isDragging,
              dragProps
            }) => (
              // write your building UI
              <div className="upload__image-wrapper">
                <div className="stopwatch" >
                  <span style={{ width: "100vh", height: "auto" }}>

                    <h3 style={{ color: 'red' }}>Configure conditions :  </h3>
                    <p style={{ color: 'red' }}>{`(SP - TC Value) >= ${conditionChiffre[0]}° : Red `} </p>
                    <p style={{ color: 'blue' }}>{` ${conditionChiffre[0]}° > (SP - TC Value) >= ${conditionChiffre[1]}° : Blue `} </p>
                    <p style={{ color: 'green' }}>{`  ${conditionChiffre[1]}° > (SP - TC Value) : Green`} </p>
                    <label for="Maximum">Maximum </label>

                    <input name='Maximum' style={{ width: 50 }} type='number' value={conditionChiffre[0]} min={conditionChiffre[1]} onChange={(e) => { if (parseInt(e.target.value) > parseInt(conditionChiffre[1])) conditionChiffre[0] = e.target.value; setConditionChiffre(conditionChiffre => [...conditionChiffre]); }}></input>
                    <pre></pre>
                    <label for="Minimum">Minimum </label>

                    <input name='Minimum' style={{ width: 50 }} type='number' value={conditionChiffre[1]} max={parseInt(conditionChiffre[0])} min={0} onChange={(e) => { if (parseInt(e.target.value) < parseInt(conditionChiffre[0])) conditionChiffre[1] = e.target.value; setConditionChiffre(conditionChiffre => [...conditionChiffre]); }}></input>
                    &nbsp;

                    <br /><br />

                  </span><br /><br />
                  <span style={{ width: "100vh", height: "auto" }}>

                    <h3 style={{ color: 'red' }}>Choose your logo</h3>
                    {imageList.length > 0 ?
                      imageList.map((image, index) => (

                        <img style={{ margin: 10, maxheight: '150px', maxWidth: "200px", marginLeft: '40%', marginRight: '40%' }} src={image.data_url} alt="" />



                      )) : <div style={{ height: "9vh" }}></div>}
                    {imageList.length > 0 ? <button className="stopwatch-btn stopwatch-btn-red" style={{ height: '50px' }} onClick={onImageRemoveAll}>Remove</button>
                      :
                      <button
                        style={{ height: '50px' }}
                        onClick={onImageUpload}
                        {...dragProps}
                        className="stopwatch-btn stopwatch-btn-gre">
                        Add
                      </button>
                    }
                    &nbsp;
                    <br /><br />

                  </span>
                </div>

              </div>
            )}
          </ImageUploading>
        </>
      )
    case 3:
      return (<LastVerification themoImages={themoImages} tapisThermocouple={tapisThermocouple} comm={comm} vacuumImage={vacuumImage} myimagelist={myimagelist} logoim={logoim} entete={entete} remarks={remarks} numberplies={numberplies} description={description} information={information}></LastVerification>)
    case 4:
      let newDate = new Date()
      let date = newDate.getDate();
      let separator = '_'
      let reportTitle = "ReportTitle"
      let month = newDate.getMonth() + 1;
      let year = newDate.getFullYear();
      var lengthFirstPart = 0;
      var tableauPayasage = typeAnita[1].map((ligne) => ligne.split(':'))


      if (activeFirstPart) { lengthFirstPart = 285 + ((tapisThermocouple.length + matUsed.length + additionalElements.length) * 10) } else { lengthFirstPart = 320 + ((tapisThermocouple.length + matUsed.length + additionalElements.length) * 20) }
      if (tapisThermocouple.length == 0 && matUsed.length == 0 && additionalElements.length == 0) lengthFirstPart -= 80
      return (
        <div style={{
          width: '140vh',
          height: '100vh  !important'
        }}>
          <div className="MyNewClass" style={{ width: "105vh", alignContent: 'center', alignItems: 'center', borderColor: { textColor }, textAlign: 'center', marginRight: 'auto', marginLeft: 'auto', marginBottom: 10 }}>

            <FormControl>
              <>Choose your Report text color </>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue={textColor}
                onChange={(e) => setTextColor(e.target.value)}>

                <FormControlLabel value="black" control={<Radio />} style={{ color: 'black' }} label="Only Black" />
                <FormControlLabel value="blue" control={<Radio />} style={{
                  background: "-webkit-linear-gradient(45deg, Black 10%, Blue 90%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent"

                }} label="Black and Blue" />
                <FormControlLabel value="grey" control={<Radio />} style={{
                  background: "-webkit-linear-gradient(45deg, Black 1%, Grey 90%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent"

                }} label="Black and Grey" />

              </RadioGroup>
            </FormControl>

          </div>
          <PDFViewer width='100%' height='850'>
            <Document title={`${date}${separator}${month < 10 ? `0${month}` : `${month}`}${separator}${year}${separator}${reportTitle}`} style={{
              width: '500px',
              height: '100vh  !important'
            }}>




              <Page style={styles.page} size="A4">
                {logoim[0] != null ? <Image src={logoim[0].data_url} alt="Forest" style={styles.headerLogo} fixed />
                  : <Image src={logo} alt="Gmi AERO" style={{ width: '55px', top: 10, left: 10, position: 'absolute' }} fixed />}

                <Text style={styles.headerID} fixed>
                  {entete[14]}-{`${date}/${month < 10 ? `0${month}` : `${month}`}/${year}`}-001
                </Text>
                <Text style={styles.cycleIdHeader}>{tableauPayasage[4][1]} </Text>

                <Svg height={lengthFirstPart} width="600">

                  {true ?
                    <>
                      {typeAnita[1].map((inputFromCSV, index) => {
                        if (!(index % 2) && (index !== 0) && index <= 23) {
                          const [first, ...rest] = inputFromCSV.split(':');
                          const [firstRow, ...restRow] = typeAnita[1][index + 1].split(':');
                          console.error("     aaaaa   " + rest[0])
                          return (
                            <>
                              {inputFromCSV !== '' ? <Polygon stroke strokeWidth={0.1} points={`0,${(index - 1) * 8} 300,${(index - 1) * 8} 300,${(index - 1) * 8} 300,${((index - 1) * 8) + 8} 300,${(index - 1) * 8} `} />
                                : null}
                              <Text x="1" y={3 + index * 8} style={styles.textSmall} > {first} </Text>
                              <Text x="140" y={3 + index * 8} style={styles.textSmall} fill={grey}> {rest.join(' ')} </Text>
                              {typeAnita[1][index + 1] !== '' ? <Polygon stroke strokeWidth={0.1} points={`310,${(index - 1) * 8} 550,${(index - 1) * 8} 550,${(index - 1) * 8} 550,${((index - 1) * 8) + 8} 550,${(index - 1) * 8} `} />
                                : null}
                              <Text x="310" y={3 + index * 8} style={styles.textSmall} > {firstRow} </Text>
                              <Text x="410" y={3 + index * 8} style={styles.textSmall} fill={grey}> {restRow.join(':')} </Text>


                            </>
                          )
                        }
                        if ( index === 24) {
                          const [first, ...rest] = inputFromCSV.split(':');
                          const [firstRow, ...restRow] = typeAnita[1][index + 1].split(':');
                          console.error("     aaaaa   " + rest[0])
                          return (
                            <>
                              {inputFromCSV !== '' ? <Polygon stroke strokeWidth={0.1} points={`0,${(index - 1) * 8} 300,${(index - 1) * 8} 300,${(index - 1) * 8} 300,${((index - 1) * 8) + 8} 300,${(index - 1) * 8} `} />
                                : null}
                              <Text x="1" y={3 + index * 8} style={styles.textSmall} > {first} </Text>
                              <Text x="140" y={3 + index * 8} style={styles.textSmall} fill={grey}> {rest.join(' ')} </Text>
                              {typeAnita[1][index + 1] !== '' ? <Polygon stroke strokeWidth={0.1} points={`310,${(index - 1) * 8} 550,${(index - 1) * 8} 550,${(index - 1) * 8} 550,${((index - 1) * 8) + 8} 550,${(index - 1) * 8} `} />
                                : null}
                              <Text x="310" y={3 + index * 8} style={styles.textSmall} > {firstRow} </Text>
                              <Text x="480" y={3 + index * 8} style={styles.textSmall} fill={grey}> {restRow.join(':')} </Text>


                            </>
                          )
                        }
                      })}
                    </>
                    : <>
                      <Text style={styles.textSmall} x="0" y="15" >{entete[0]}</Text>
                      <Text x="165" y="15" style={styles.textSmall} fill={grey}> {entete[14]} </Text>
                      {
                        activeFirstPart ? null : <><Polygon stroke strokeWidth={1} points="0,20 345,20 345,40 345,20" />
                          <Text style={styles.textSmall} fill={black} x="0" y="35">{entete[1]} </Text><Text x="165" y="35" style={styles.textSmall} fill={grey}>{entete[15]}</Text></>}
                      <Polygon stroke strokeWidth={1} points=" 350,20 550,20 550,40 550,20" />
                      <Text style={styles.textSmall} x="350" y="35" >Date :</Text><Text x="400" y="35" fill={grey} style={styles.textSmall} > 03/15/2022</Text>
                      {activeFirstPart ? <></> : <> <Polygon stroke strokeWidth={1} points=" 0,45 200,45 200,65 200,45 " />
                        <Text style={styles.textSmall} x="0" y="60" >{entete[2]} </Text><Text x="100" y="60" fill={grey} style={styles.textSmall} > {entete[16]}</Text>
                        <Polygon stroke strokeWidth={1} points=" 210,45 345,45 345,65 345,45 " />
                        <Text style={styles.textSmall} x="210" y="60">{entete[3]} </Text><Text x="275" y="60" fill={grey} style={styles.textSmall}> {entete[17]}</Text>
                        <Polygon stroke strokeWidth={1} points=" 350,45 550,45 550,65 550,45 " />
                        <Text style={styles.textSmall} x="350" y="60">{entete[4]}</Text><Text x="400" y="60" fill={grey} style={styles.textSmall} > {entete[18]}</Text>
                        <Polygon stroke strokeWidth={1} points=" 0,70 345,70 345,90 345,70 " />
                        <Text style={styles.textSmall} x="0" y="85">{entete[5]}</Text><Text x="100" y="85" fill={grey} style={styles.textSmall} >  {entete[19]}</Text>
                        <Polygon stroke strokeWidth={1} points=" 350,70 550,70 550,90 550,70 " />
                        <Text style={styles.textSmall} x="350" y="85">{entete[6]}</Text><Text x="400" y="85" fill={grey} style={styles.textSmall}> {entete[20]}</Text>
                      </>}


                      {activeFirstPart ? <>
                        <Text style={styles.textSmall} x="6" y="65">Repair Unit Data:</Text>
                        <Text style={styles.textSmall} x="120" y="65">{entete[7]}</Text><Text x="190" y="65" fill={grey} style={styles.textSmall}> {entete[21]}</Text>
                        <Text style={styles.textSmall} x="350" y="65">{entete[8]}  </Text><Text x="430" y="65" fill={grey} style={styles.textSmall}> {entete[22]}</Text>
                        <Text style={styles.textSmall} x="5" y="100">Damage Dimension</Text>
                        <Text style={styles.textSmall} x="120" y="90">{entete[9]}</Text><Text x="190" y="90" fill={grey} style={styles.textSmall}> {entete[23]}</Text>
                        <Text style={styles.textSmall} x="255" y="90">{entete[10]}</Text><Text x="300" y="90" fill={grey} style={styles.textSmall}> {entete[24]}</Text>
                        <Text style={styles.textSmall} x="350" y="90">{entete[11]}  </Text><Text x="430" y="90" fill={grey} style={styles.textSmall}> {entete[25]}</Text>
                        <Text style={styles.textSmall} x="120" y="110">{entete[12]}  </Text><Text x="190" y="110" fill={grey} style={styles.textSmall}> {entete[26]}</Text>
                        <Text style={styles.textSmall} x="350" y="110">{entete[13]} </Text><Text x="430" y="110" fill={grey} style={styles.textSmall}> {entete[27]}</Text>
                        <Polygon fill={"black"} stroke strokeWidth={2} points="0,50 550,50" />
                        <Polygon fill={"black"} stroke strokeWidth={2} points="0,75 550,75" />
                        <Polygon fill={"black"} stroke strokeWidth={2} points="1,50 1,115" />
                        <Polygon fill={"black"} stroke strokeWidth={2} points="550,50 550,115" />
                        <Polygon fill={"black"} stroke strokeWidth={0.1} points="115,95 550,95" />
                        <Polygon fill={"black"} stroke strokeWidth={2} points="115,75 115,115" />
                        <Polygon fill={"black"} stroke strokeWidth={2} points="0,115 550,115" />
                      </> : <>
                        <Text style={styles.textSmall} x="6" y="115">Repair Unit Data:</Text>
                        <Text style={styles.textSmall} x="120" y="115">{entete[7]}</Text><Text x="190" y="115" fill={grey} style={styles.textSmall}> {entete[21]}</Text>
                        <Text style={styles.textSmall} x="350" y="115">{entete[8]}  </Text><Text x="430" y="115" fill={grey} style={styles.textSmall}> {entete[22]}</Text>
                        <Text style={styles.textSmall} x="5" y="150">Damage Dimension</Text>
                        <Text style={styles.textSmall} x="120" y="140">{entete[9]}</Text><Text x="190" y="140" fill={grey} style={styles.textSmall}> {entete[23]}</Text>
                        <Text style={styles.textSmall} x="255" y="140">{entete[10]}</Text><Text x="300" y="140" fill={grey} style={styles.textSmall}> {entete[24]}</Text>
                        <Text style={styles.textSmall} x="350" y="140">{entete[11]}  </Text><Text x="430" y="140" fill={grey} style={styles.textSmall}> {entete[25]}</Text>
                        <Text style={styles.textSmall} x="120" y="160">{entete[12]}  </Text><Text x="190" y="160" fill={grey} style={styles.textSmall}> {entete[26]}</Text>
                        <Text style={styles.textSmall} x="350" y="160">{entete[13]} </Text><Text x="430" y="160" fill={grey} style={styles.textSmall}> {entete[27]}</Text>
                        <Polygon fill={"black"} stroke strokeWidth={2} points="0,100 550,100" />
                        <Polygon fill={"black"} stroke strokeWidth={2} points="0,125 550,125" />
                        <Polygon fill={"black"} stroke strokeWidth={2} points="1,100 1,165" />
                        <Polygon fill={"black"} stroke strokeWidth={2} points="550,100 550,165" />
                        <Polygon fill={"black"} stroke strokeWidth={0.1} points="115,145 550,145" />
                        <Polygon fill={"black"} stroke strokeWidth={2} points="115,125 115,165" />
                        <Polygon fill={"black"} stroke strokeWidth={2} points="0,165 550,165" />
                      </>}

                    </>}
                  {// rajouter la taille du tableau de l'entete du csv 4.0
                  }
                  {activeFirstPart ? firstGap -= 50 : firstGap += (30 * 2)}

                  {tapisThermocouple.length > 0 || matUsed.length > 0 ? <>
                    <Text style={styles.textSmall} x="5" y={firstGap + 15} >Phase</Text>
                    <Text x="60" y={firstGap + 15} style={styles.textSmall}>Item</Text>
                    <Text x="506" y={firstGap + 10} style={styles.superSmall}>Performed </Text>
                    <Text x="520" y={firstGap + 17} style={styles.superSmall}> by</Text>

                    <Polygon fill={"black"} stroke strokeWidth={2} points={"1," + (1 + firstGap) + " 550," + (1 + firstGap) + ""} />
                    <Polygon fill={"black"} stroke strokeWidth={2} points={"1," + (20 + firstGap) + " 550," + (20 + firstGap) + ""} />
                    <Polygon fill={"black"} stroke strokeWidth={2} points={"1," + (1 + firstGap) + " 1," + (60 + firstGap + ((tapisThermocouple.length + matUsed.length + additionalElements.length) * 20)) + ""} />
                    <Polygon fill={"black"} stroke strokeWidth={2} points={"504," + (1 + firstGap) + " 504," + (60 + firstGap + ((tapisThermocouple.length + matUsed.length + additionalElements.length) * 20)) + ""} />
                    <Polygon fill={"black"} stroke strokeWidth={2} points={"550," + (1 + firstGap) + " 550," + (60 + firstGap + ((tapisThermocouple.length + matUsed.length + additionalElements.length) * 20)) + ""} />
                    <Polygon fill={"black"} stroke strokeWidth={2} points={"50," + (1 + firstGap) + " 50," + (20 + firstGap) + ""} />

                    <Text x="70" y={firstGap + 35} style={styles.superSmall}>Material used :(Adhesives, Pre-preg, honeycomb core; filler, ect)</Text>
                    <Text x="5" y={firstGap + 35} style={styles.superSmall}>Tracability</Text>

                    <Text x="70" y={firstGap + 55} style={styles.textSmall}>Material Part Numbers </Text>
                    <Text x="250" y={firstGap + 55} style={styles.textSmall}>Serial Number </Text>
                    <Text x="460" y={firstGap + 55} style={styles.textSmall}>Type</Text>
                    <Polygon fill={"black"} stroke strokeWidth={2} points={"1," + (60 + firstGap) + " 550," + (60 + firstGap) + ""} />
                    {tapisThermocouple.map((element, index) => {


                      return (
                        <>
                          <Text x="50" y={firstGap + 75 + (index * 20)} style={styles.textSmall} fill={grey}>{element.zid}</Text>
                          <Text x="250" y={firstGap + 75 + (index * 20)} style={styles.textSmall} fill={grey}>{element.pn}</Text>
                          <Text x="460" y={firstGap + 75 + (index * 20)} style={styles.textSmall} fill={grey}>TC</Text>
                          <Polygon fill={"black"} stroke strokeWidth={0.1} points={"50," + (80 + firstGap + (index * 20)) + " 550," + (80 + firstGap + (index * 20)) + ""} />
                        </>
                      )


                    })}
                    {/* la condition ci-dessous pour prolonger la taille du tableau */}
                    {matUsed.length >= 1 ? matUsedGap = tapisThermocouple.length * 20 : null}
                    {matUsed.map((element, index) => {


                      return (
                        <>
                          <Text x="50" y={firstGap + matUsedGap + 75 + (index * 20)} style={styles.textSmall} fill={grey}>{element.zid}</Text>
                          <Text x="250" y={firstGap + matUsedGap + 75 + (index * 20)} style={styles.textSmall} fill={grey}>{element.pn}</Text>

                          <Text x="460" y={firstGap + matUsedGap + 75 + (index * 20)} style={styles.superSmall} fill={grey}>Blanket</Text>
                          <Polygon fill={"black"} stroke strokeWidth={0.1} points={"50," + (80 + firstGap + matUsedGap + (index * 20)) + " 550," + (80 + firstGap + matUsedGap + (index * 20)) + ""} />
                        </>
                      )


                    })}
                    {/* la condition ci-dessous pour prolonger la taille du tableau */}
                    {additionalElements.length >= 1 ? matUsedGap += matUsed.length * 20 : null}
                    {additionalElements.map((element, index) => {


                      return (
                        <>
                          <Text x="50" y={firstGap + matUsedGap + 75 + (index * 20)} style={styles.textSmall} fill={grey}>{element.zid}</Text>
                          <Text x="250" y={firstGap + matUsedGap + 75 + (index * 20)} style={styles.textSmall} fill={grey}>{element.pn}</Text>
                          <Text x="460" y={firstGap + matUsedGap + 75 + (index * 20)} style={styles.superSmall} fill={grey}>Other</Text>
                          <Polygon fill={"black"} stroke strokeWidth={0.1} points={"50," + (80 + firstGap + matUsedGap + (index * 20)) + " 550," + (80 + firstGap + matUsedGap + (index * 20)) + ""} />
                        </>
                      )
                    })}
                    <Polygon fill={"black"} stroke strokeWidth={0.1} points={"455," + (45 + firstGap) + " 455," + (60 + firstGap + ((tapisThermocouple.length + matUsed.length + additionalElements.length) * 20)) + ""} />
                    <Polygon fill={"black"} stroke strokeWidth={0.1} points={"240," + (45 + firstGap) + " 240," + (60 + firstGap + ((tapisThermocouple.length + matUsed.length + additionalElements.length) * 20)) + ""} />
                    <Polygon fill={"black"} stroke strokeWidth={2} points={"1," + (60 + firstGap + ((tapisThermocouple.length + matUsed.length + additionalElements.length) * 20)) + " 550," + (60 + firstGap + ((tapisThermocouple.length + matUsed.length + additionalElements.length) * 20)) + ""} />
                  </> : null}
                </Svg>

                {/** pour afficher les images rajoutees au niveau de ADDITIONAL ELEMENTS */}
                {additionalElementsPictures.length > 0 ?
                  <Text style={styles.textSmall}>Additional pictures : </Text> : null}
                {additionalElementsPictures.map((l, index) => {
                  return (
                    <>
                      {l[1] == null ? null : <Text style={styles.title} >Title {index + 1} : {l[1]}</Text>}

                      <Image src={l.data_url} alt="Gmi AERO" style={{
                        maxHeight: 250, maxWidth: 'auto', marginVertical: 15,
                        marginHorizontal: 100
                      }} ></Image>
                      {l[2] == null ? null : <Text style={{ fontSize: 10 }}  >Description : {l[2]}</Text>}
                    </>
                  )
                })}


                <Svg height={longThirdPart} width="1200">
                  <Polygon fill={"black"} stroke strokeWidth={2} points={"1," + (1 + secondGap) + " 550," + (1 + secondGap) + ""} />
                  <Text x="45" y={secondGap + 20} style={styles.textSmall}>Drying and Water Break Test performed : </Text> <Text x="270" y={secondGap + 20} style={styles.textSmall} fill={grey} > {entete[28]} </Text>
                  <Polygon fill={"black"} stroke strokeWidth={2} points={"50," + (30 + secondGap) + " 550," + (30 + secondGap) + ""} />
                  <G transform="rotate(270) translate(-130,-45)">
                    <Text x="5" y={secondGap + 70} style={styles.textSmall}>Preperation</Text>
                  </G>
                  <Text x="45" y={secondGap + 42} style={styles.smallest}>Direction and amount of ply lay up (for sandwich structure or monolithic parts)</Text>
                  <Text x="45" y={secondGap + 50} style={styles.superSmall}>NOTE: Reference Direction is oriented on the existing last production layer.</Text>
                  {calculatedangles.slice(0, numberplies).map((row, indexe) => {
                    var index = indexe;
                    if (indexe >= 8) { index = indexe - 8; secondGap = 65; } else {
                      index = indexe;
                    }
                    return (
                      <>
                        <Circle
                          cx={60 + index * 60}
                          cy={secondGap + 75}
                          r="20"
                          fill={beige}
                          stroke="gray"
                        />
                        {/* la condition ci-dessous pour éviter que les remarques succesives ne soient sur la meme ligne */}
                        {index % 2 === 0 ?

                          <><Text x={35 + index * 60} y={secondGap + 107} style={styles.smallest} >{remarks[indexe]}</Text>
                          </> :

                          <><Text x={35 + index * 60} y={secondGap + 101} style={styles.smallest} >{remarks[indexe]}</Text>
                          </>
                        }


                        {/* la condition ci-dessous pour eviter que le chiffre de l'angles ne soit sur la ligne d'inclinaison */}

                        {Math.abs(angles[indexe]) > 90 && Math.abs(angles[indexe]) < 270 ?

                          <><Text x={52 + index * 60} y={secondGap + 70} style={styles.superSmall} >{angles[indexe]}</Text>
                            <Text x={67 + index * 60} y={secondGap + 70} style={styles.superSmall} >°</Text>
                          </> :

                          <><Text x={52 + index * 60} y={secondGap + 85} style={styles.superSmall} >{angles[indexe]}</Text>
                            <Text x={67 + index * 60} y={secondGap + 85} style={styles.superSmall} >°</Text>
                          </>
                        }
                        {/* la condition ci-dessous car pour les numéros à deux chiffres il faut s'éloigner un peu plus du cercle pour éviter d'écrire sur ce dernier */}

                        {indexe >= 8 ? <Text x={30 + index * 60} y={secondGap + 70} style={styles.superSmall} >{indexe + 1}</Text> : <Text x={33 + index * 60} y={secondGap + 70} style={styles.superSmall} >{indexe + 1}</Text>}

                        {/* la condition ci-dessous car après chaques 8 cercles on doit faire un retour à la ligne et donc on utiliste indexE et non pas index */}
                        {indexe >= 8 ?
                          <Polygon fill={"black"} stroke="1" points={(60 + (index * 60)) + "," + (secondGap + 75) + " " + (calculatedangles[indexe][0] + (60 + (index * 60))) + "," + (calculatedangles[indexe][1] + secondGap + 75)} ></Polygon>
                          : <Polygon fill={"black"} stroke="1" points={(60 + (index * 60)) + "," + (secondGap + 75) + " " + (calculatedangles[index][0] + (60 + (index * 60))) + "," + (calculatedangles[index][1] + secondGap + 75)} ></Polygon>
                        }

                      </>
                    );
                  })}

                  {activeDesc ? null :
                    <>  <Text x="45" y={secondGap + 120} style={styles.superSmall}>Description of the process :</Text>
                      {description ?
                        <>
                          <Text x="35" y={secondGap + 130} fill={grey} style={styles.superSmall} >{description.substring(0, 96)}</Text>
                        </> :
                        null
                      }
                      {description.length >= 96 ?
                        <>
                          <Text x="35" y={secondGap + 140} fill={grey} style={styles.superSmall} >{description.substring(96, 192)}</Text>
                        </> :
                        null
                      }
                      {description.length >= 192 ?
                        <>
                          <Text x="35" y={secondGap + 150} fill={grey} style={styles.superSmall} >{description.substring(192, 288)}</Text>
                        </> :
                        null
                      }
                      {description.length >= 288 ?
                        <>
                          <Text x="35" y={secondGap + 160} fill={grey} style={styles.superSmall} >{description.substring(288)}</Text>
                        </> :
                        null
                      }</>}

                  {description.length >= 96 && !activeDesc ? secondGap += (Math.round(description.length / 96)) * 5 : null}
                  {activeDesc ? secondGap -= 30 : null}
                  <Polygon fill={"black"} stroke strokeWidth={2} points={"1," + (1) + " 1," + (160 + secondGap) + ""} />
                  <Polygon fill={"black"} stroke strokeWidth={2} points={"550," + (1) + " 550," + (160 + secondGap) + ""} />
                  <Polygon fill={"black"} stroke strokeWidth={2} points={"504," + (1) + " 504," + (160 + secondGap) + ""} />
                  <Polygon fill={"black"} stroke strokeWidth={2} points={"1," + (160 + secondGap) + " 550," + (160 + secondGap) + ""} />
                  <Polygon fill={"black"} stroke strokeWidth={2} points={"50," + (145 + secondGap) + " 550," + (145 + secondGap) + ""} />
                  <Text x="35" y={secondGap + 155} style={styles.superSmall}></Text>
                  <Text x="180" y={secondGap + 155} style={styles.superSmall} fill={grey} ></Text>
                </Svg>








                <Svg height={60}>  
                <Polygon fill='black' stroke strokeWidth={1} points={"270,29 390,29"}></Polygon>
                <Polygon fill='black' stroke strokeWidth={1} points={"270,44 390,44"}></Polygon>

                <Polygon fill='black' stroke strokeWidth={1} points={"410,29 520,29"}></Polygon>
                <Polygon fill='black' stroke strokeWidth={1} points={"410,44 520,44"}></Polygon>

                <Polygon fill='black' stroke strokeWidth={1} points={"10,29 130,29"}></Polygon>
                <Polygon fill='black' stroke strokeWidth={1} points={"10,44 130,44"}></Polygon>

                <Polygon fill='black' stroke strokeWidth={1} points={"150,29 260,29"}></Polygon>
                <Polygon fill='black' stroke strokeWidth={1} points={"150,44 260,44"}></Polygon>

                <Text x="10" y="10" style={styles.superSmall}>Recording of ambient Temperature and Humidity :</Text>
                <Text x="20" y="25" style={styles.superSmall}>Automatic via ANITA 4.0 :</Text>
                <Text x="20" y="40" style={styles.superSmall}>Ambient Temperature:	  °C	</Text>	<Text x="160" y="40" style={styles.superSmall}>Ambient Humidity:    %</Text>
                <Text x="280" y="25" style={styles.superSmall}>Manual via Operator :</Text>
                <Text x="280" y="40" style={styles.superSmall}>Ambient Temperature:	  °C </Text>	<Text x="420" y="40" style={styles.superSmall}>		Ambient Humidity:    %</Text>
                </Svg>



                {/** la partie du rapport de lufthansa qui a éré supprimée */}
                {/*<Svg height="164" width="1200">
                  <Polygon fill={"black"} stroke strokeWidth={2} points={"1," + (1 + thirdGap) + " 550," + (1 + thirdGap) + ""} />
                  <Text style={styles.textSmall} x="5" y={thirdGap + 15} >Record Temperature and Pressure of bonding procedure:</Text>

                  <Polygon fill={"black"} stroke strokeWidth={0.1} points={"1," + (20 + thirdGap) + " 550," + (20 + thirdGap) + ""} />

                  <Text style={styles.textSmall} x="5" y={thirdGap + 35} >Bonding-/cure report added to this Report</Text>
                  <Text x="350" y={thirdGap + 35} style={styles.textSmall} > Yes [_]</Text>
                  <Text x="400" y={thirdGap + 35} style={styles.textSmall} > No [_]</Text>
                  <Polygon fill={"black"} stroke strokeWidth={2} points={"1," + (40 + thirdGap) + " 550," + (40 + thirdGap) + ""} />


                  <Text style={styles.textSmall} x="5" y={thirdGap + 55} >Record Temperature and Pressure if automatic cure record is not available</Text>
                  <Polygon fill={"black"} stroke strokeWidth={0.1} points={"1," + (60 + thirdGap) + " 550," + (60 + thirdGap) + ""} />




                  <Text style={styles.textSmall} x="5" y={thirdGap + 75} >Temperature</Text>
                  <Polygon fill={"black"} stroke strokeWidth={0.1} points={"105," + (60 + thirdGap) + " 105," + (80 + thirdGap) + ""} />
                  <Text x="120" y={thirdGap + 75} style={styles.textSmall} fill={grey}> -- </Text>
                  <Polygon fill={"black"} stroke strokeWidth={2} points={"270," + (60 + thirdGap) + " 270," + (80 + thirdGap) + ""} />
                  <Text style={styles.textSmall} x="280" y={thirdGap + 75} >Curing Duration</Text>
                  <Polygon stroke strokeWidth={0.1} points={"375," + (60 + thirdGap) + " 375," + (80 + thirdGap) + ""} />
                  {/* calculer la durée du cycle */}
                  {/*<Text style={styles.textSmall} x="380" y={thirdGap + 75} fill={grey} >{`${parseInt(mesTemperatures[mesTemperatures.length - 2][0]) * 1 + 1} min`}</Text>
                  <Polygon fill={"black"} stroke strokeWidth={0.1} points={"1," + (80 + thirdGap) + " 550," + (80 + thirdGap) + ""} />




                  <Text style={styles.textSmall} x="5" y={thirdGap + 95} >Pressure</Text>
                  <Polygon fill={"black"} stroke strokeWidth={0.1} points={"105," + (80 + thirdGap) + " 105," + (100 + thirdGap) + ""} />
                  <Text x="120" y={thirdGap + 95} style={styles.textSmall} fill={grey}>-- </Text>
                  <Polygon fill={"black"} stroke strokeWidth={2} points={"270," + (80 + thirdGap) + " 270," + (100 + thirdGap) + ""} />
                  <Text style={styles.textSmall} x="280" y={thirdGap + 95} >DATA! </Text>
                  <Polygon stroke strokeWidth={0.1} points={"375," + (80 + thirdGap) + " 375," + (100 + thirdGap) + ""} />
                  <Text style={styles.textSmall} x="380" y={thirdGap + 95} fill={grey}>DATA! </Text>
                  <Polygon fill={"black"} stroke strokeWidth={2} points={"1," + (100 + thirdGap) + " 550," + (100 + thirdGap) + ""} />

                  <Text style={styles.textSmall} x="5" y={thirdGap + 115} >Record Ambient</Text>
                  <Polygon fill={"black"} stroke strokeWidth={0.1} points={"1," + (120 + thirdGap) + " 550," + (120 + thirdGap) + ""} />

                  <Text style={styles.textSmall} x="5" y={thirdGap + 135} >Humidity</Text>
                  <Polygon fill={"black"} stroke strokeWidth={0.1} points={"105," + (120 + thirdGap) + " 105," + (140 + thirdGap) + ""} />
                  <Text x="120" y={thirdGap + 135} style={styles.textSmall} fill={grey}> -- </Text>

                  <Polygon fill={"black"} stroke strokeWidth={2} points={"270," + (120 + thirdGap) + " 270," + (140 + thirdGap) + ""} />
                  <Text style={styles.textSmall} x="280" y={thirdGap + 135} >Temperature </Text>
                  <Polygon stroke strokeWidth={0.1} points={"375," + (120 + thirdGap) + " 375," + (140 + thirdGap) + ""} />
                  <Text style={styles.textSmall} x="380" y={thirdGap + 135} fill={grey}>-- </Text>
                  <Polygon fill={"black"} stroke strokeWidth={0.1} points={"1," + (140 + thirdGap) + " 550," + (140 + thirdGap) + ""} />

                  <Text style={styles.textSmall} x="5" y={thirdGap + 155} >Record Number if thermocouples used : </Text>
                  <Text x="250" y={thirdGap + 155} style={styles.textSmall} fill={grey}> 19 </Text>

                  <Polygon stroke strokeWidth={2} points={"504," + (thirdGap) + " 504," + (160 + thirdGap) + ""} />

                  <Polygon fill={"black"} stroke strokeWidth={2} points={"1," + (1 + thirdGap) + " 1," + (160 + thirdGap) + ""} />
                  <Polygon fill={"black"} stroke strokeWidth={2} points={"550," + (1 + thirdGap) + " 550," + (160 + thirdGap) + ""} />
                  <Polygon fill={"black"} stroke strokeWidth={2} points={"1," + (160 + thirdGap) + " 550," + (160 + thirdGap) + ""} />

                </Svg>*/}

                <Svg height="61" width="1200">
                  <Polygon fill={"black"} stroke strokeWidth={2} points="1,1 550,1" />
                  <Text style={styles.textSmall} x="5" y="15" >Report Completed by</Text>
                  <Polygon fill={"black"} stroke strokeWidth={0.1} points="130,1 130,20" />
                  <Text style={styles.textSmall} x="140" y="15" >Date</Text>

                  <Text x="170" y="15" fill={grey} style={styles.textSmall}>{`${date}/${month < 10 ? `0${month}` : `${month}`}/${year}`}</Text>
                  <Polygon fill={"black"} stroke strokeWidth={2} points="270,1 270,20" />
                  <Text style={styles.textSmall} x="280" y="15" >Department</Text>

                  <Text x="400" y="15" fill={grey} style={styles.textSmall}>--</Text>

                  <Polygon fill={"black"} stroke strokeWidth={0.1} points="1,20 550,20" />

                  <Text style={styles.textSmall} x="5" y="35" >Name</Text>
                  <Polygon fill={"black"} stroke strokeWidth={0.1} points="130,20 130,40" />
                  <Text x="140" y="35" style={styles.textSmall} fill={grey}>{entete[14]} </Text>
                  <Polygon fill={"black"} stroke strokeWidth={2} points="270,20 270,40" />
                  <Text style={styles.textSmall} x="280" y="35" >Stamp/Signature</Text>
                  <Polygon stroke strokeWidth={0.1} points="375,20 375,40" />
                  <Text style={styles.textSmall} x="380" y="35" fill={grey} ></Text>

                  <Polygon fill={"black"} stroke strokeWidth={2} points="1,1 1,40" />
                  <Polygon fill={"black"} stroke strokeWidth={2} points="1,40 375,40" />
                  <Polygon fill={"black"} stroke strokeWidth={2} points="375,40 375,60" />
                  <Polygon fill={"black"} stroke strokeWidth={2} points="550,1 550,60" />
                  <Polygon fill={"black"} stroke strokeWidth={2} points="375,60 550,60" />

                </Svg>
                <Image src={logo} alt="Gmi AERO" style={{ width: '55px', bottom: 10, left: 10, position: 'absolute' }} fixed />

                <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (`${pageNumber} / ${totalPages}`)} fixed />
                <Text style={styles.copyRight} fixed > ReportApp-Copyright © GMI Aero 2022</Text>

              </Page>

              <Page style={styles.page} size="A4" orientation='landscape'>
                {logoim[0] != null ? <Image src={logoim[0].data_url} alt="Forest" style={styles.headerLogo} fixed />
                  : <Image src={logo} alt="Gmi AERO" style={{ width: '55px', top: 10, left: 10, position: 'absolute' }} fixed />}

                <Text style={styles.headerID} fixed>
                  {entete[14]}-{`${date}/${month < 10 ? `0${month}` : `${month}`}/${year}`}-001
                </Text>
                <Text style={styles.cycleIdHeader} fixed>{tableauPayasage[4][1]} </Text>

                <Svg height="130" width="1200">
                  <Polygon fill={"black"} stroke strokeWidth={2} points="1,2 470,2" />
                  <Text style={styles.textSmall} x="5" y="15" >ID Cycle</Text>
                  <Polygon fill={"black"} stroke strokeWidth={0.1} points="105,1 105,20" />
                  <Text x="120" y="15" fill={grey} style={styles.textSmall}>{tableauPayasage[4][1]}</Text>
                  <Polygon fill={"black"} stroke strokeWidth={2} points="1,20 470,20" />

                  <Text style={styles.textSmall} x="5" y="35" >ID Recipe</Text>
                  <Polygon fill={"black"} stroke strokeWidth={0.1} points="105,20 105,40" />
                  <Text x="120" y="35" style={styles.textSmall} fill={grey}>{tableauPayasage[5][1]} </Text>
                  <Polygon fill={"black"} stroke strokeWidth={2} points="270,20 270,40" />
                  <Text style={styles.textSmall} x="280" y="35" >Heating method</Text>
                  <Polygon stroke strokeWidth={0.1} points="375,20 375,40" />
                  <Text style={styles.textSmall} x="380" y="35" fill={grey} >{tableauPayasage[20][1]}</Text>
                  <Polygon fill={"black"} stroke strokeWidth={0.5} points="1,40 470,40" />


                  <Text style={styles.textSmall} x="5" y="55" >Start at</Text>
                  <Polygon fill={"black"} stroke strokeWidth={0.1} points="105,40 105,60" />
                  <Text x="120" y="55" style={styles.textSmall} fill={grey}>{`${tableauPayasage[2][1]}  ${tableauPayasage[3][1]}:${tableauPayasage[3][2]}:${tableauPayasage[3][3]}`}</Text>
                  <Polygon fill={"black"} stroke strokeWidth={2} points="270,40 270,60" />
                  <Text style={styles.textSmall} x="280" y="55" >Operator</Text>
                  <Polygon stroke strokeWidth={0.1} points="375,40 375,60" />

                  <Text style={styles.textSmall} x="380" y="55" fill={grey} >{tableauPayasage[6][1]}</Text>
                  <Polygon fill={"black"} stroke strokeWidth={2} points="1,60 470,60" />




                  <Text style={styles.textSmall} x="5" y="75" >Console S/N</Text>
                  <Polygon fill={"black"} stroke strokeWidth={0.1} points="105,60 105,80" />
                  <Text x="120" y="75" style={styles.textSmall} fill={grey}> {tableauPayasage[8][1]} </Text>
                  <Polygon fill={"black"} stroke strokeWidth={2} points="270,60 270,80" />
                  <Text style={styles.textSmall} x="280" y="75" >Calibration date</Text>
                  <Polygon stroke strokeWidth={0.1} points="375,60 375,80" />
                  <Text style={styles.textSmall} x="380" y="75" fill={grey} >{tableauPayasage[9][1]}</Text>
                  <Polygon fill={"black"} stroke strokeWidth={0.1} points="1,80 470,80" />




                  <Text style={styles.textSmall} x="5" y="95" >Inventory number</Text>
                  <Polygon fill={"black"} stroke strokeWidth={0.1} points="105,80 105,100" />
                  <Text x="120" y="95" style={styles.textSmall} fill={grey}> {tableauPayasage[8][1]} </Text>
                  <Polygon fill={"black"} stroke strokeWidth={2} points="270,80 270,100" />
                  <Text style={styles.textSmall} x="280" y="95" >Software Version </Text>
                  <Polygon stroke strokeWidth={0.1} points="375,80 375,100" />
                  <Text style={styles.textSmall} x="380" y="95" fill={grey}>{tableauPayasage[10][1]} </Text>
                  <Polygon fill={"black"} stroke strokeWidth={2} points="1,100 470,100" />


                  <Polygon fill={"black"} stroke strokeWidth={2} points="470,2   780,2  " />
                  <Text style={styles.textSmall} x="475" y="15" >T/C Channel</Text>
                  <Text style={styles.textSmall} x="555" y="15" fill={grey}>---</Text>
                  <Polygon fill={"black"} stroke strokeWidth={0.1} points="470,20   780,20  " />
                  <Text style={styles.textSmall} x="475" y="35" >Vacuum line</Text>
                  <Text style={styles.textSmall} x="555" y="35" fill={grey}>---</Text>
                  <Polygon fill={"black"} stroke strokeWidth={0.1} points="550,2   550,40  " />

                  <Polygon fill={"black"} stroke strokeWidth={0.1} points="470,40   780,40  " />
                  <Text style={styles.textSmall} x="475" y="55" >Zone 1</Text>
                  <Text x="520" y="55" style={styles.textSmall} fill={grey}>{tableauPayasage[18][2]} </Text>
                  <Text style={styles.textSmall} x="580" y="55" >Zone 2</Text>
                  <Text x="620" y="55" style={styles.textSmall} fill={grey}>  {tableauPayasage[19][2]}  </Text>
                  <Text style={styles.textSmall} x="685" y="55" >Zone 3</Text>
                  {/* Il y a des csv sans la lignes zone 3 d'ou ça genere une erreur */}
                  <Text x="725" y="55" style={styles.textSmall} fill={grey}>  {(tableauPayasage[20] !== "undefined" && tableauPayasage[20] !== null && Array.isArray(tableauPayasage[20])) ? tableauPayasage[20][2] : 'non'}   </Text>
                  <Polygon fill={"black"} stroke strokeWidth={0.1} points="470,60   780,60  " />
                  <Text style={styles.textSmall} x="475" y="75" >PID</Text>
                  <Polygon fill={"black"} stroke strokeWidth={0.1} points="500,60   500,80  " />
                  <Text x="505" y="75" style={styles.textSmall} fill={grey}> --  </Text>
                  <Polygon fill={"black"} stroke strokeWidth={2} points="650,60   650,80  " />
                  <Text x="655" y="75" style={styles.textSmall} > Scanner </Text>
                  <Polygon fill={"black"} stroke strokeWidth={0.1} points="710,60   710,80  " />
                  <Text x="715" y="75" style={styles.textSmall} fill={grey}> ---  </Text>

                  <Polygon fill={"black"} stroke strokeWidth={2} points="470,80   780,80  " />
                  <Text style={styles.textSmall} x="475" y="95" >Part name</Text>
                  <Polygon fill={"black"} stroke strokeWidth={0.1} points="550,80   550,100  " />
                  <Text x="555" y="95" style={styles.textSmall} fill={grey}> {`${tableauPayasage[13][1]}`} </Text>
                  <Polygon fill={"black"} stroke strokeWidth={0.1} points="470,100   780,100  " />
                  <Text style={styles.textSmall} x="475" y="115" >Third party</Text>
                  <Polygon fill={"black"} stroke strokeWidth={0.1} points="550,100   550,120  " />
                  <Text x="555" y="115" style={styles.textSmall} fill={grey}> {`${tableauPayasage[13][1]}`}    </Text>











                  <Text style={styles.textSmall} x="5" y="115" >Part S/N</Text>
                  <Polygon fill={"black"} stroke strokeWidth={0.1} points="105,100 105,120" />
                  <Text x="120" y="115" style={styles.textSmall} fill={grey}> {`${tableauPayasage[11][1]}`}  </Text>
                  <Polygon fill={"black"} stroke strokeWidth={0.1} points="1,120 470,120" />
                  <Polygon fill={"black"} stroke strokeWidth={2} points="270,100 270,120" />

                  <Text style={styles.textSmall} x="280" y="115" >Part P/N</Text>
                  <Polygon fill={"black"} stroke strokeWidth={0.1} points="345,100 345,120" />

                  <Text style={styles.textSmall} x="350" y="115" fill={grey}> {`${tableauPayasage[12][1]}`}</Text>



                  <Polygon fill={"black"} stroke strokeWidth={2} points="1,1 1,120" />
                  <Polygon fill={"black"} stroke strokeWidth={2} points="470,1 470,120" />
                  <Polygon fill={"black"} stroke strokeWidth={2} points="780,1 780,120" />
                  <Polygon fill={"black"} stroke strokeWidth={2} points="1,120 780,120" />

                </Svg>



                <Image src={imgSource} alt="Gmi AERO" style={{
                  maxHeight: 360, maxWidth: 'auto', marginVertical: 10,
                  marginHorizontal: 10
                }} ></Image>




                {themoImages.map((l, index) => {
                  return (
                    <>

                      <Image src={l.data_url} alt="Gmi AERO" maxHeight='600px' style={{
                        maxHeight: 350, maxWidth: 'auto', marginVertical: 10,
                        marginHorizontal: 10
                      }} ></Image>
                    </>
                  )
                })
                }
                <Image src={logo} alt="Gmi AERO" style={{ width: '55px', bottom: 10, left: 10, position: 'absolute' }} fixed />

                <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (`${pageNumber} / ${totalPages}`)} fixed />
                <Text style={styles.copyRight} fixed > ReportApp-Copyright © GMI Aero 2022</Text>


              </Page>

              <Page style={styles.page} size="A4" >
                {logoim[0] != null ? <Image src={logoim[0].data_url} alt="Forest" style={styles.headerLogo} fixed />
                  : <Image src={logo} alt="Gmi AERO" style={{ width: '55px', top: 10, left: 10, position: 'absolute' }} fixed />}
                <Text style={styles.cycleIdHeader}>{tableauPayasage[4][1]} </Text>
                <Text style={styles.headerID} fixed>
                  {entete[14]}-{`${date}/${month < 10 ? `0${month}` : `${month}`}/${year}`}
                </Text>
                <Image src={logo} alt="Gmi AERO" style={{ width: '55px', bottom: 10, left: 10, position: 'absolute' }} fixed />

                <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (`${pageNumber} / ${totalPages}`)} fixed />
                <Text style={styles.copyRight} fixed > ReportApp-Copyright © GMI Aero 2022</Text>


                {descriptionCourbe.length > 0 &&

                  descriptionCourbe.map((item, i) =>
                    <>
                      <li >

                        <ul>
                          <Svg height={15}>
                          <Text style={styles.superSmall} fill={"blue"} x='10' y='13' >{item[0]}</Text>
                          <Text style={styles.superSmall} fill={"red"} x='70' y='13' >{item[1]}</Text>
                          <Text style={styles.superSmall} fill={""} x='85' y='13' >{item[2]+" :" }</Text>
                          <Polygon fill={"black"} stroke strokeWidth={0.1} points={`10,4 500,4`} />

                          </Svg>
                          <Text style={styles.superSmall}  fill={"blue"}> {item[3]}</Text>
                        </ul>
 
                      </li>
                    </>)}
              </Page>


              {
                runCallback(() => {
                  const row = [];

                  if (mesTemperatures.length >= 49) {
                    for (var i = 0; i < (Math.round(mesTemperatures.length / 49)); i++) {
                      row.push(<Page style={styles.page} size="A4" orientation='landscape'>
                        {logoim[0] != null ? <Image src={logoim[0].data_url} alt="Forest" style={styles.headerLogo} fixed />
                          : <Image src={logo} alt="Gmi AERO" style={{ width: '55px', top: 10, left: 10, position: 'absolute' }} fixed />}
                        <Text style={styles.cycleIdHeader}>{tableauPayasage[4][1]} </Text>
                        <Text style={styles.headerID} fixed>
                          {entete[14]}-{`${date}/${month < 10 ? `0${month}` : `${month}`}/${year}`}
                        </Text>
                        <Image src={logo} alt="Gmi AERO" style={{ width: '55px', bottom: 10, left: 10, position: 'absolute' }} fixed />

                        <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (`${pageNumber} / ${totalPages}`)} fixed />
                        <Text style={styles.copyRight} fixed > ReportApp-Copyright © GMI Aero 2022</Text>
                        <Svg  >
                          <Text style={styles.superSmall} y={"525"} fixed >{` Color code : `} </Text>
                          <Text style={styles.superSmall} fill={"red"} y={"525"} x={"50"} fixed >{`(SP - TC Value) >= ${conditionChiffre[0]}° : Red , `} </Text>
                          <Text style={styles.superSmall} fill={"blue"} y={"525"} x={"170"} fixed >{` ${conditionChiffre[0]}° > (SP - TC Value) >= ${conditionChiffre[1]}° : Blue , `} </Text>
                          <Text style={styles.superSmall} fill={"green"} y={"525"} x={"315"} fixed >{`  ${conditionChiffre[1]}° > (SP - TC Value) : Green`} </Text>
                          {i !== 0 ? <>{mesTemperatures[0].map((column, indexC) => {
                            //indexColomun c'est X , on fait -25 pour que la premiere soit zero (grace a la ligne au dessus)
                            // (index === 0 ? (indexColomun) : (indexColomun + 3) si on est pas dans la premiere ligne on rajoute 3 pixels pour que les temperatures soient un peut plus au centre
                            // (index === 0 ? (column) : (column * 1)) on fait ça pour que les temperature 0.0 apparaissent 0 , sauf pour la premiere ligne on la laisse comme elle est (time,setpipont ....)
                            var indexColo = indexC * 26;
                            return (<>


                              <Text style={styles.superSmall}
                                fill=
                                {
                                  'black'
                                }
                                y={11}
                                x={(indexColo + 3)} >

                                {(column === 'Vacuum 2' || column === 'Vide 2') ? 'Vac 2' :
                                  (column === 'Vacuum 1' || column === 'Vide 1') ? 'Vac 1' :
                                    indexC === 1 ? 'SP' : (column)
                                }
                              </Text>

                              <Polygon fill={"black"} stroke strokeWidth={0.1} points={`${(indexColo + 1)},${(3)} ${(indexColo + 1)},${(14)}`} />

                            </>)
                          })}

                            <Polygon fill={"black"} stroke strokeWidth={0.1} points={`${(mesTemperatures[0].length * 26)},3 ${((mesTemperatures[0].length) * 26)},${(14)}`} />
                            <Polygon fill={"black"} stroke strokeWidth={0.1} points={`1,3 ${((mesTemperatures[0].length) * 26)},3`} />

                          </> : null}
                          {mesTemperatures.slice(i * 49).map((ligne, index) => {
                            if (index < mesTemperatures.slice(i * 49).length - 1 && index < 49) {
                              var indexColomun = -26

                              return (
                                ligne.map((column, indexC) => {
                                  //indexColomun c'est X , on fait -25 pour que la premiere soit zero (grace a la ligne au dessus)
                                  indexColomun += 26
                                  // (index === 0 ? (indexColomun) : (indexColomun + 3) si on est pas dans la premiere ligne on rajoute 3 pixels pour que les temperatures soient un peut plus au centre
                                  // (index === 0 ? (column) : (column * 1)) on fait ça pour que les temperature 0.0 apparaissent 0 , sauf pour la premiere ligne on la laisse comme elle est (time,setpipont ....)
                                  return (<>


                                    <Text style={styles.superSmall}
                                      fill=
                                      {
                                        ((index === 0 && i === 0) || (parseInt(column) === 0) || [0, 1, ligne.length - 1, ligne.length - 2, ligne.length - 3, ligne.length - 4].indexOf(indexC) > -1) ? 'black' :
                                          (Math.abs(parseFloat(column) - parseFloat(ligne[1])) >= conditionChiffre[0]) ? 'red' :
                                            (Math.abs(parseFloat(column) - parseFloat(ligne[1])) < conditionChiffre[0] && Math.abs(parseFloat(column) - parseFloat(ligne[1])) >= conditionChiffre[1]) ? 'blue' :
                                              'green'
                                      }
                                      y={22 + (index * 10)}
                                      x={(index === 0 && i === 0 ? (indexColomun + 3) : (indexColomun + 3))} >

                                      {(index === 0 && i === 0 && (column === 'Vacuum 2' || column === 'Vide 2')) ? 'Vac 2' :
                                        (index === 0 && i === 0 && (column === 'Vacuum 1' || column === 'Vide 1')) ? 'Vac 1' :
                                          (index === 0 && i === 0 && indexC === 1) ? 'SP' :
                                            (index === 0 && i === 0 ? (column) :
                                              (column === 'NaN') ? ('--') : (column * 1))
                                      }
                                    </Text>

                                    <Polygon fill={"black"} stroke strokeWidth={0.1} points={`${(indexColomun + 1)},${(13 + (index * 10))} ${(indexColomun + 1)},${(24 + (index * 10))}`} />

                                  </>)
                                })
                              )
                            }
                          })
                          }

                          {mesTemperatures.slice(i * 49).map((ligne, index) => {

                            if (index < mesTemperatures.slice(i * 49).length - 1 && index < 49) {
                              if (index !== 0)
                                return (
                                  <Polygon fill={"black"} stroke strokeWidth={0.1} points={`1,${(24 + (index * 10))} ${(mesTemperatures[0].length * 26)},${(24 + (index * 10))}`} />
                                )
                              else
                                return (
                                  <> <Polygon fill={"black"} stroke strokeWidth={0.1} points={`1,${(13 + (index * 10))} ${(mesTemperatures[0].length * 26)},${(13 + (index * 10))}`} />
                                    <Polygon fill={"black"} stroke strokeWidth={0.1} points={`1,${(24 + (index * 10))} ${(mesTemperatures[0].length * 26)},${(24 + (index * 10))}`} />

                                  </>
                                )
                            }
                          })}

                          <Polygon fill={"black"} stroke strokeWidth={0.1} points={`${(mesTemperatures[0].length * 26)},12 ${((mesTemperatures[0].length) * 26)},${(14 + ((mesTemperatures.slice(i * 49).length < 49 ? mesTemperatures.slice(i * 49).length - 1 : 49) * 10))}`} />


                        </Svg>



                      </Page>)
                    }
                  }
                  else {
                    row.push(<Page style={styles.page} size="A4" orientation='landscape'>
                      {logoim[0] != null ? <Image src={logoim[0].data_url} alt="Forest" style={styles.headerLogo} fixed />
                        : <Image src={logo} alt="Gmi AERO" style={{ width: '55px', top: 10, left: 10, position: 'absolute' }} fixed />}

                      <Text style={styles.headerID} fixed>
                        {entete[14]}-{`${date}/${month < 10 ? `0${month}` : `${month}`}/${year}`}-001
                      </Text>

                      <Image src={logo} alt="Gmi AERO" style={{ width: '55px', bottom: 10, left: 10, position: 'absolute' }} fixed />

                      <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (`${pageNumber} / ${totalPages}`)} fixed />
                      <Text style={styles.copyRight} fixed > ReportApp-Copyright © GMI Aero 2022</Text>

                      <Svg>
                        <Text style={styles.superSmall} y={"525"} fixed >{` Color code : `} </Text>
                        <Text style={styles.superSmall} fill={"red"} y={"525"} x={"50"} fixed >{`(SP - TC Value) >= ${conditionChiffre[0]}° : Red , `} </Text>
                        <Text style={styles.superSmall} fill={"blue"} y={"525"} x={"170"} fixed >{` ${conditionChiffre[0]}° > (SP - TC Value) >= ${conditionChiffre[1]}° : Blue , `} </Text>
                        <Text style={styles.superSmall} fill={"green"} y={"525"} x={"315"} fixed >{`  ${conditionChiffre[1]}° > (SP - TC Value) : Green`} </Text>
                        {mesTemperatures.map((ligne, index) => {
                          if (index < mesTemperatures.length - 1) {
                            var indexColomun = -26

                            return (
                              ligne.map((column, indexC) => {
                                console.log(index === 0 && indexC === 1)
                                //indexColomun c'est X , on fait -25 pour que la premiere soit zero (grace a la ligne au dessus)
                                indexColomun += 26
                                // (index === 0 ? (indexColomun) : (indexColomun + 3) si on est pas dans la premiere ligne on rajoute 3 pixels pour que les temperatures soient un peut plus au centre
                                // (index === 0 ? (column) : (column * 1)) on fait ça pour que les temperature 0.0 apparaissent 0 , sauf pour la premiere ligne on la laisse comme elle est (time,setpipont ....)
                                return (<>


                                  <Text style={styles.superSmall}
                                    fill=
                                    {
                                      ((index === 0) || (parseInt(column) === 0) || [0, 1, ligne.length - 1, ligne.length - 2, ligne.length - 3, ligne.length - 4].indexOf(indexC) > -1) ? 'black' :
                                        (Math.abs(parseFloat(column) - parseFloat(ligne[1])) >= conditionChiffre[0]) ? 'red' :
                                          (Math.abs(parseFloat(column) - parseFloat(ligne[1])) < conditionChiffre[0] && Math.abs(parseFloat(column) - parseFloat(ligne[1])) >= conditionChiffre[1]) ? 'blue' :
                                            'green'
                                    }
                                    y={15 + (index * 10)}
                                    x={(index === 0 ? (indexColomun + 3) : (indexColomun + 3))} >

                                    {(index === 0 && (column === 'Vacuum 2' || column === 'Vide 2')) ? 'Vac 2' :
                                      (index === 0 && (column === 'Vacuum 1' || column === 'Vide 1')) ? 'Vac 1' :
                                        (index === 0 && indexC === 1) ? 'SP' :
                                          (index === 0 ? (column) :
                                            (column === 'NaN') ? ('--') : (column * 1))
                                    }

                                  </Text>

                                  <Polygon fill={"black"} stroke strokeWidth={0.1} points={`${(indexColomun + 1)},${(6 + (index * 10))} ${(indexColomun + 1)},${(17 + (index * 10))}`} />

                                </>)
                              })
                            )
                          }
                        })
                        }

                        {mesTemperatures.map((ligne, index) => {

                          if (index < mesTemperatures.length - 1) {
                            if (index !== 0)
                              return (
                                <Polygon fill={"black"} stroke strokeWidth={0.1} points={`1,${(17 + (index * 10))} ${(mesTemperatures[0].length * 26)},${(17 + (index * 10))}`} />
                              )
                            else
                              return (
                                <> <Polygon fill={"black"} stroke strokeWidth={0.1} points={`1,${(6 + (index * 10))} ${(mesTemperatures[0].length * 26)},${(6 + (index * 10))}`} />
                                  <Polygon fill={"black"} stroke strokeWidth={0.1} points={`1,${(17 + (index * 10))} ${(mesTemperatures[0].length * 26)},${(17 + (index * 10))}`} />

                                </>
                              )
                          }
                        })}


                        <Polygon fill={"black"} stroke strokeWidth={0.1} points={`${(mesTemperatures[0].length * 26)},5 ${(mesTemperatures[0].length * 26)},${(7 + ((mesTemperatures.length - 1) * 10))}`} />

                      </Svg>


                    </Page>)
                  }
                  return (row);
                })
              }



              <Page style={styles.page} size="A4">
                {logoim[0] != null ? <Image src={logoim[0].data_url} alt="Forest" style={styles.headerLogo} fixed />
                  : <Image src={logo} alt="Gmi AERO" style={{ width: '55px', top: 10, left: 10, position: 'absolute' }} fixed />}

                <Text style={styles.headerID} fixed>
                  {entete[14]}-{`${date}/${month < 10 ? `0${month}` : `${month}`}/${year}`}-001
                </Text>
                <Text style={styles.cycleIdHeader}>{tableauPayasage[4][1]} </Text>


                {listEvents.length >= 1 ?
                  <>
                    <Svg height={"16"} width="800" >
                      <Text x="230" y="14" style={styles.textSmall}>Table of Events</Text>
                    </Svg>
                    <Svg height={listEvents.length * 12 + 42} width="800" >
                      <Polygon fill={"black"} stroke strokeWidth={0.1} points={`1,15 550,15 `} />
                      <Text style={styles.superSmall} x="55" y={25} >Time</Text><Text style={styles.superSmall} x="150" y={25} >Event</Text>
                      <Polygon fill={"black"} stroke strokeWidth={0.1} points={`1,27 550,27`} />
                      {listEvents.map((eventAnita, index) => {

                        return (<><Text style={styles.superSmall} x="50" y={index * 12 + 38} >{eventAnita.time}</Text><Text style={styles.superSmall} x="150" y={index * 12 + 38} >{eventAnita.event}</Text>
                          <Polygon fill={"black"} stroke strokeWidth={0.1} points={`1,${index * 12 + 40} 550,${index * 12 + 40} `} />


                        </>)
                      })}
                      <Polygon fill={"black"} stroke strokeWidth={0.1} points={`1,15 1,${(listEvents.length - 1) * 12 + 40} `} />
                      <Polygon fill={"black"} stroke strokeWidth={0.1} points={`550,15 550,${(listEvents.length - 1) * 12 + 40} `} />
                      <Polygon fill={"black"} stroke strokeWidth={0.1} points={`140,15 140,${(listEvents.length - 1) * 12 + 40} `} />

                    </Svg></> : null}



                {typeof information[1] !== "undefined" && information[1] !== null && information.length[1] !== null ?
                  <>
                    <View wrap={false}>
                      <Svg height={40} width="1000">
                        <Text x="200" y="25" style={styles.textSmall}>Figure : Vacuum Bag Diagram</Text>
                      </Svg>

                      <Svg height={(30 * information[1].length + 50)} width="1000">
                        <Polyline
                          points={"1,1 1," + (information[1].length * 30 + 40) + " 500," + (information[1].length * 30 + 40) + " 500,1 1,1"}
                          stroke="black"
                          strokeWidth={0.5}
                        />
                        {information[1].map(({ id, color, thumb, value, numberLayers }, index) => {
                          return (
                            <>
                              <Polyline
                                points={"20," + (index * 30 + 10) + " 470," + (index * 30 + 10) + " 470," + (index * 30 + 35) + " 20," + (index * 30 + 35) + " 20," + (index * 30 + 10) + ""}
                                stroke={grey !== 'black' ? color : grey}
                                strokeWidth={1}
                              />

                              <Polyline
                                points={"450," + (index * 30 + 12) + " 468," + (index * 30 + 12) + " 468," + (index * 30 + 33) + " 450," + (index * 30 + 33) + " 450," + (index * 30 + 12) + ""}
                                stroke={grey !== 'black' ? color : grey}
                                fill={color}
                                fillOpacity={grey !== 'black' ? '0.4' : '0'}
                                strokeWidth={0.5}
                              />


                              <Text x="80" y={index * 30 + 28} style={styles.textSmall}>
                                {value}
                              </Text>
                              <Text x="310" style={{ fontSize: 5 }} y={index * 30 + 28}>
                                Number of layers
                              </Text>
                              <Text x="370" y={index * 30 + 28} style={styles.textSmall}>
                                {numberLayers}
                              </Text>


                            </>
                          );
                        })}

                        <Polyline
                          // cadre parent
                          points={"15,5 475,5 475," + ((30 * information[1].length) + 5) + " 15," + ((30 * information[1].length) + 5) + " 15,5 "}
                          stroke="grey"
                          strokeWidth={1}
                        />
                        <Polyline
                          // cadre parent
                          points={"12," + ((30 * information[1].length) + 5) + " 480," + (30 * information[1].length + 5) + " 490," + (30 * information[1].length + 35) + " 5," + (30 * information[1].length + 35) + " 12," + (30 * information[1].length + 5)}
                          stroke="black"
                          strokeWidth={1}
                        />
                        <Polyline
                          // cadre parent
                          points={"100," + (30 * information[1].length + 5) + " 100," + (30 * information[1].length + 10) + " 400," + (30 * information[1].length + 10) + " 400," + (30 * information[1].length + 5)}
                          strokeWidth={1}
                          stroke="black"
                        />
                        <Polyline
                          // cadre parent
                          points={"125," + (30 * information[1].length + 10) + " 125," + (30 * information[1].length + 15) + " 375," + (30 * information[1].length + 15) + " 375," + (30 * information[1].length + 10) + " "}
                          stroke="black"
                          strokeWidth={1}
                        />

                        <Polyline
                          // cadre parent
                          points={"150," + (30 * information[1].length + 15) + " 150," + (30 * information[1].length + 5 + 15) + " 350," + (30 * information[1].length + 20) + " 350," + (30 * information[1].length + 15) + " "}
                          stroke="black"
                          strokeWidth={1}
                        />
                        <Text x="30" y={30 * information[1].length + 25} style={styles.textSmall}>
                          Repair Patch
                        </Text>
                      </Svg>

                      {/** pour afficher les images rajoutees au niveau de Vacuum Bagging */}
                      {vacuumImage.length > 0 ?
                        <Text style={styles.textSmall}>Additional pictures for the Vacuum Bag </Text> : null}
                      {vacuumImage.map((l, index) => {
                        return (
                          <>
                            {l[1] == null ? null : <Text style={styles.title} >Title {index + 1} : {l[1]}</Text>}

                            <Image src={l.data_url} alt="Gmi AERO" style={{
                              maxHeight: 250, maxWidth: 'auto', marginVertical: 15,
                              marginHorizontal: 100
                            }} ></Image>
                            {l[2] == null ? null : <Text style={{ fontSize: 10 }}  >Description : {l[2]}</Text>}
                          </>
                        )
                      })}



                      <Text style={{ fontSize: 10 }}  >{comm}</Text>
                    </View>
                  </> : null}


                {myimagelist.map((l, index) => {
                  if (index === 0) {
                    return (

                      <>
                        <Text style={styles.title} wrap={false}>Annex</Text>
                        {l[1] == null ? null : <Text style={styles.title} >Title {index + 1}: {l[1]}</Text>}
                        <Image src={l.data_url} alt="Gmi AERO" style={{
                          maxHeight: 250, maxWidth: 'auto', marginVertical: 15,
                          marginHorizontal: 100
                        }} ></Image>
                        {l[2] == null ? null : <Text style={{ fontSize: 10 }}  >Description : {l[2]}</Text>}
                      </>

                    )
                  }
                  else
                    return (
                      <>
                        {l[1] == null ? null : <Text style={styles.title} >Title {index + 1} : {l[1]}</Text>}
                        <Image src={l.data_url} alt="Gmi AERO" style={{
                          maxHeight: 250, maxWidth: 'auto', marginVertical: 15,
                          marginHorizontal: 100
                        }} ></Image>
                        {l[2] == null ? null : <Text style={{ fontSize: 10 }}  >Description : {l[2]}</Text>}
                      </>
                    )
                })}


                <Image src={logo} alt="Gmi AERO" style={{ width: '55px', bottom: 10, left: 10, position: 'absolute' }} fixed />

                <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (`${pageNumber} / ${totalPages}`)} fixed />
                <Text style={styles.copyRight} fixed > ReportApp-Copyright © GMI Aero 2022</Text>
              </Page>















            </Document>



          </PDFViewer></div>);
    default:
      return 'Unknown step';
  }
}

export default function GeneratedReport({ descriptionCourbe,listEvents, mesTemperatures, setImgSource, typeAnita, imgSource, matUsed, additionalElements, urlCaptureImage, remarks, setRemarks, setEntete, entete, numberplies, setNumberplies, angles, setAngles, open, handleSubmit, dialogValue, setDialogValue, toggleOpen, handleClose, remarksAuto, calculatedangles, setCalculatedangles, description, setDescription, activeCircle, setActiveCircle, activeDesc, setActiveDesc, tapisThermocouple, comm, information, myimagelist, themoImages, vacuumImage, additionalElementsPictures }) {
  const [statusData, setStatusData] = React.useState([]);
  var [conditionChiffre, setConditionChiffre] = React.useState([8, 3])
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const [textColor, setTextColor] = React.useState("blue");

  const [activeFirstPart, setActiveFirstPart] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  var steps = getSteps();


  const [value, setValue] = React.useState(null);


  const [openParam, toggleOpenParam] = React.useState(false);


  const imprim = () => {


    var newImg = document.createElement('img'),
      url = URL.createObjectURL(urlCaptureImage[0]);

    newImg.onload = function () {
      // no longer need to read the blob so it's revoked
      URL.revokeObjectURL(url);

    };
    urlCaptureImage[0] = url
    newImg.src = url;
    document.getElementById("x").appendChild(newImg);


  }






  const isStepOptional = (step) => {
    return step === 10;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };



  const handleReset = () => {
    setActiveStep(0);
  };
  var [logoim, setLogoim] = React.useState([]);
  return (
    <Fragment>
      <Stepper activeStep={activeStep} className={classes.root} style={{ borderRadius: 15, width: '95%', height: '2px' }}>
        {steps.map((label, index) => {
          const stepProps = {};
          const labelProps = {};
          if (isStepOptional(index)) {
            labelProps.optional = <Typography variant="caption">Optional</Typography>;
          }
          if (isStepSkipped(index)) {
            stepProps.completed = false;
          }
          return (
            <Step key={label} {...stepProps}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
      <div className={classes.root}>

        <div>

          <div>
            <Typography className={classes.instructions}>{getStepContent(descriptionCourbe,listEvents, conditionChiffre, setConditionChiffre, mesTemperatures, setImgSource, typeAnita, urlCaptureImage, imprim, remarks, setRemarks, tapisThermocouple, logoim, setLogoim, themoImages, vacuumImage, myimagelist, comm, activeFirstPart, setActiveFirstPart, openParam, toggleOpenParam, setEntete, entete, classes, activeStep, information, numberplies, setNumberplies, angles, setAngles, value, setValue, open, handleSubmit, dialogValue, setDialogValue, toggleOpen, handleClose, remarksAuto, calculatedangles, setCalculatedangles, description, setDescription, activeCircle, setActiveCircle, activeDesc, setActiveDesc, textColor, setTextColor, matUsed, additionalElements, imgSource, additionalElementsPictures)}</Typography>

            <div className={classes.divButton}>
              <Button disabled={activeStep === 0} onClick={handleBack} className={classes.button}>
                Back
              </Button>

              <Button
                variant="contained"
                color="primary"
                onClick={handleNext}
                className={classes.button}
                disabled={activeStep === 4 || (imgSource == "-1" && activeStep === 1)}
              >

                {(function () {
                  if (activeStep === 0) {
                    return 'Choose Chart';
                  }
                  if (activeStep === 1) {
                    return 'Configuration';
                  }
                  else if (activeStep === 2) {
                    return 'Verification';
                  }
                  else if (activeStep === 3) {
                    return 'Generate Report';
                  } else {
                    return 'Finish'
                  }
                })()}

              </Button>
            </div>

          </div>

        </div>

      </div>
    </Fragment>
  );
}
